import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Images from "../../assests/Images"

const Sidebar = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [isSidebarOpen, setSidebarOpen] = useState(!isMobile);

  let role = sessionStorage.getItem("rolebase")

  const handleResize = () => {
    const mobile = window.innerWidth <= 1024;
    setIsMobile(mobile);
    setSidebarOpen(!mobile);
  };

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate('/');
  };

  return (
    <>
      {isMobile && (
        <button className="sidebar_toggle_btn" onClick={toggleSidebar}>
          ☰
        </button>
      )}

      {isMobile && isSidebarOpen && (
        <div className="sidebar_backdrop" onClick={toggleSidebar}></div>
      )}

      <div className={`sidebar_block ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar_logo_block">
          {/* <div className="logo_image_block">
            <img src={Images?.logo} alt="logo" className="image_icon" />
          </div> */}
          <h5 className="sidebar_logo_heading">DENVAR TRADERS</h5>
        </div>
        <ul className="sidebar_menu">


          {
            role == "admin" && (
              <>

                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.dashboard}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/" className="sidebar_menu_item">
                    DASHBOARD
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.viewOrder}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/viewOrder" className="sidebar_menu_item">
                    VIEW ORDER
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.newOrder}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/newOrder" className="sidebar_menu_item">
                    NEW ORDER
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.viewProduct}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/viewProduct" className="sidebar_menu_item">
                    VIEW PRODUCT
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.addProduct}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/addProduct" className="sidebar_menu_item">
                    NEW PRODUCT
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.viewPurchase}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/viewPurchase" className="sidebar_menu_item">
                    VIEW PURCHASE
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.newPurchase}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/newPurchase" className="sidebar_menu_item">
                    NEW PURCHASE
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.customers}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/viewCustomer" className="sidebar_menu_item">
                    VIEW CUSTOMER
                  </Link>
                </li>{" "}
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.customers}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/newCustomer" className="sidebar_menu_item">
                    ADD CUSTOMER
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.viewExe}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/viewExecutive" className="sidebar_menu_item">
                    VIEW EXECUTIVE
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img src={Images?.newExe} alt="no-image" className="image_icon" />
                  </div>
                  <Link to="/newExecutive" className="sidebar_menu_item">
                    NEW EXECUTIVE
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img
                      src={Images?.profile}
                      alt="no-image"
                      className="image_icon"
                    />
                  </div>
                  <Link to="/profile" className="sidebar_menu_item">
                    PROFILE
                  </Link>
                </li>
                <li className="sidebar_menu_list">
                  <div className="list_image_block">
                    <img src={Images?.logout} alt="no-image" className="image_icon" />
                  </div>
                  <Link onClick={handleLogout} className="sidebar_menu_item">
                    LOGOUT
                  </Link>
                </li>
              </>
            )
          }
          {role == "Sales" && (
            <>
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.viewOrder}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/" className="sidebar_menu_item">
                  VIEW ORDER
                </Link>
              </li>
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.newOrder}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/newOrder" className="sidebar_menu_item">
                  NEW ORDER
                </Link>
              </li>
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.viewProduct}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/viewProduct" className="sidebar_menu_item">
                  VIEW PRODUCT
                </Link>
              </li>
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.addProduct}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/addProduct" className="sidebar_menu_item">
                  NEW PRODUCT
                </Link>
              </li>
              {/* <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.viewPurchase}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/viewPurchase" className="sidebar_menu_item">
                  VIEW PURCHASE
                </Link>
              </li>
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.newPurchase}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/newPurchase" className="sidebar_menu_item">
                  NEW PURCHASE
                </Link>
              </li> */}
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.customers}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/viewCustomer" className="sidebar_menu_item">
                  VIEW CUSTOMER
                </Link>
              </li>{" "}
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img
                    src={Images?.customers}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
                <Link to="/newCustomer" className="sidebar_menu_item">
                  ADD CUSTOMER
                </Link>
              </li>
              <li className="sidebar_menu_list">
                <div className="list_image_block">
                  <img src={Images?.logout} alt="no-image" className="image_icon" />
                </div>
                <Link onClick={handleLogout} className="sidebar_menu_item">
                  LOGOUT
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
